export default API => ({
    // 获取配置信息
    configuration(data){
        return API({
            url:`/modular/admin/v1/configuration/${data}`,
            method:'get',
        })
    },
    configurationNew(data){
        return API({
            url:`/modular/admin/v1/configurations/${data}`,
            method:'get',
        })
    }
})